import React, { useEffect, useState } from "react";
import "./index.css";
import { toast } from "react-toastify";
import {
  checkoutAPI,
  clearCartAPI,
  getCartData,
  getAccountData,
  updateCart,
  getWalletData,
} from "../../services/AuthServices";
import { useNavigate, Link } from "react-router-dom";
import _, { add } from "lodash";
import Loader from "../../containers/Loader";
import logo from "../../assets/images/dream-prize.jpeg";
import CartPaymentPopup from "./CartPaymentPopup";
import PaymentMethodPopup from "./PaymentMethodPopup";


const MainSection = () => {
  const [cart, setCart] = useState({});
  const [address, setaddress] = useState();
  const [checkoutLoading, setcheckoutLoading] = useState(false);
  const [isLoading, setisLoading] = useState(false);
  const [userData, setUserData] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [transactionInProgress, setTransactionInProgress] = useState(false);
  const [showPaymentMethodModal, setShowPaymentMethodModal] = useState(false);
  const [walletBalance, setWalletBalance] = useState(0);
  const [selectedItems, setSelectedItems] = useState([]);
  const [billingDetails, setBillingDetails] = useState({
    fullName: '',
    phone: '',
    email: '',
    mobile: '',
    addressLine: '',
    city: '',
    state: '',
    pincode: '',
  });
  const [saveAddress, setSaveAddress] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    getData(true);
    fetchUserData();
  }, []);

  // Initialize selectedItems when cart data loads
  useEffect(() => {
    const items = cart?.cart_products?.filter((item) => item?.qty > 0) || [];
    setSelectedItems(items.map((item) => item?.id));
  }, [cart]);

  // Prefill billing details from user data
  useEffect(() => {
    if (userData) {
      setBillingDetails((prev) => ({
        ...prev,
        fullName: userData?.full_name || prev.fullName,
        email: userData?.email || prev.email,
        phone: userData?.phone_number || prev.phone,
        mobile: userData?.phone_number || prev.mobile,
      }));
    }
  }, [userData]);

  const fetchUserData = async () => {
    try {
      const [accountResponse, walletResponse] = await Promise.all([
        getAccountData(),
        getWalletData(1),
      ]);
      setUserData(accountResponse?.data?.data);
      setWalletBalance(walletResponse?.data?.data?.wallet?.balance || 0);
    } catch (error) {
      console.log("Could not fetch user data for prefill");
    }
  };

  const getData = async (firstCall) => {
    firstCall && setisLoading(true);
    await getCartData()
      .then((response) => {
        setCart(response?.data?.cart);
        firstCall && setisLoading(false);
      })
      .catch((error) => {
        firstCall && setisLoading(true);
        toast("Something went wrong", { type: "error" });
      });
  };

  const clearCart = async () => {
    await clearCartAPI()
      .then((response) => {
        setCart({ ...cart, cart_products: [] });
        getData();
        toast("Cart cleared successfully", { type: "success" });
      })
      .catch((error) => {
        toast("Something went wrong", { type: "error" });
      });
  };

  const updateQty = async (id, qty, existingQty, stock) => {
    if (qty < 0) {
      return toast("Please enter proper Quantity", { type: "error" });
    } else if (qty > stock) {
      return toast("Please enter proper Quantity", { type: "error" });
    } else {
      let formdata = new FormData();
      formdata.append("product_id", id);
      formdata.append("quantity", qty);
      await updateCart(formdata)
        .then((response) => {
          getData();
          if (qty > existingQty) {
            toast("Product added to cart successfully", { type: "success" });
          } else if (qty === 0) {
            toast("Product removed from cart successfully", { type: "success" });
          } else {
            toast("Cart updated successfully", { type: "success" });
          }
        })
        .catch((error) => {
          toast("Something went wrong", { type: "error" });
        });
    }
  };

  const checkoutClicked = async () => {
    if (!billingDetails.fullName.trim()) {
      return toast("Please enter your full name", { type: "error" });
    }
    if (!billingDetails.phone.trim() && !billingDetails.mobile.trim()) {
      return toast("Please enter your phone number", { type: "error" });
    }
    if (!billingDetails.addressLine.trim()) {
      return toast("Please enter your address", { type: "error" });
    }
    if (!billingDetails.city.trim()) {
      return toast("Please enter your city", { type: "error" });
    }
    if (!billingDetails.state.trim()) {
      return toast("Please enter your state", { type: "error" });
    }
    if (!billingDetails.pincode.trim()) {
      return toast("Please enter your pincode", { type: "error" });
    }
    if (!cart?.total_amount || cart.total_amount <= 0) {
      return toast("Invalid cart amount", { type: "error" });
    }
    const fullAddress = buildFullAddress();
    setaddress(fullAddress);
    setShowPaymentMethodModal(true);
  };

  const handleWalletPayment = () => {
    setShowPaymentMethodModal(false);
    navigate("/wallet");
  };

  const handleDirectPayment = () => {
    setShowPaymentMethodModal(false);
    setcheckoutLoading(true);
    handlePayment();
  };

  const handlePayment = () => {
    const amount = cart?.total_amount || 0;
    if (amount <= 0) {
      toast("Invalid cart amount", { type: "error" });
      setcheckoutLoading(false);
      return;
    }

    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY,
      amount: amount * 100,
      currency: "INR",
      name: "Dream Prize",
      description: `Order Payment - Cart #${cart?.id}`,
      image: logo,
      handler: function (response) {
        setTransactionInProgress(true);
        setShowPaymentModal(true);
        processCheckout(response?.razorpay_payment_id);
      },
      prefill: {
        name: userData?.full_name || "",
        email: userData?.email || "",
        contact: userData?.phone_number || "",
      },
      theme: {
        color: "#7000ff",
      },
      modal: {
        ondismiss: function () {
          setcheckoutLoading(false);
          toast("Payment cancelled. Your cart is saved.", { type: "info" });
        },
      },
    };

    const razor = new window.Razorpay(options);
    razor.open();
  };

  const processCheckout = async (paymentId) => {
    let formdata = new FormData();
    formdata.append("address", address);
    formdata.append("cart_id", cart?.id);
    formdata.append("sub_total", cart?.sub_total || 0);
    formdata.append("tax_amount", cart?.tax_amount || 0);
    formdata.append("total_amount", cart?.total_amount || 0);
    formdata.append("payment_id", paymentId);

    try {
      await checkoutAPI(formdata);
      setTransactionInProgress(false);
      setTimeout(() => {
        setShowPaymentModal(false);
        setcheckoutLoading(false);
        setCart({ ...cart, cart_products: [] });
        toast("Order placed successfully!", { type: "success" });
        navigate("/");
      }, 2000);
    } catch (error) {
      setTransactionInProgress(false);
      setTimeout(() => {
        setShowPaymentModal(false);
        setcheckoutLoading(false);
        setCart({ ...cart, cart_products: [] });
        toast("Order placed successfully!", { type: "success" });
        navigate("/");
      }, 2000);
    }
  };

  const handleSelectAll = (checked) => {
    const items = cart?.cart_products?.filter((item) => item?.qty > 0) || [];
    if (checked) {
      setSelectedItems(items.map((item) => item?.id));
    } else {
      setSelectedItems([]);
    }
  };

  const handleSelectItem = (itemId, checked) => {
    if (checked) {
      setSelectedItems((prev) => [...prev, itemId]);
    } else {
      setSelectedItems((prev) => prev.filter((id) => id !== itemId));
    }
  };

  const handleBillingChange = (field, value) => {
    setBillingDetails((prev) => ({ ...prev, [field]: value }));
  };

  const buildFullAddress = () => {
    const parts = [
      billingDetails.addressLine,
      billingDetails.city,
      billingDetails.state,
      billingDetails.pincode,
    ].filter(Boolean);
    return parts.join(', ');
  };

  const cartItems = cart?.cart_products?.filter((item) => item?.qty > 0) || [];
  const itemCount = cartItems.length;
  const isAllSelected = itemCount > 0 && selectedItems.length === itemCount;
  const rawSavings = (cart?.sub_total || 0) - (cart?.total_amount || 0) + (cart?.tax_amount || 0);
  const savings = Math.round(rawSavings * 100) / 100;

  return (
    <div className="dp-cart-page">
      <div className="dp-cart-container">
        {/* Breadcrumb */}
        <div className="dp-cart-breadcrumb">
          <Link to="/">
            <i className="far fa-home"></i> Home
          </Link>
          <span>&gt;</span>
          <span className="current">Cart</span>
        </div>

        {/* Page Header */}
        <div className="dp-cart-header">
          <div className="dp-cart-title">
            <div>
              <h1>
                <i className="far fa-shopping-cart"></i>
                Proceed to Checkout
              </h1>
              <p>Complete your order by providing the details below</p>
            </div>
          </div>
          {itemCount > 0 && (
            <div className="dp-cart-header-badges">
              <div className="dp-cart-badge">
                <i className="far fa-box"></i>
                {itemCount} {itemCount === 1 ? 'Item' : 'Items'} in Cart
              </div>
              <div className="dp-free-shipping-badge">
                <i className="far fa-truck"></i>
                Free shipping on orders above Rs.500
              </div>
            </div>
          )}
        </div>

        {isLoading ? (
          <div className="dp-cart-loading">
            <Loader />
          </div>
        ) : itemCount === 0 ? (
          <div className="dp-cart-items-section">
            <div className="dp-empty-cart">
              <div className="dp-empty-cart-icon">
                <i className="far fa-shopping-cart"></i>
              </div>
              <h3>Your Cart is Empty</h3>
              <p>Looks like you haven't added anything to your cart yet</p>
              <Link to="/games" className="dp-empty-cart-btn">
                <i className="far fa-store"></i>
                Start Shopping
              </Link>
            </div>
          </div>
        ) : (
          <>
            {/* Checkout Steps */}
            <div className="dp-checkout-steps">
              <div className="dp-step completed">
                <span className="dp-step-number">
                  <i className="fas fa-check"></i>
                </span>
                <span className="dp-step-label">Cart Items</span>
              </div>
              <div className="dp-step-connector active"></div>
              <div className="dp-step active">
                <span className="dp-step-number">2</span>
                <span className="dp-step-label">Billing Details</span>
              </div>
              <div className="dp-step-connector inactive"></div>
              <div className="dp-step inactive">
                <span className="dp-step-number">3</span>
                <span className="dp-step-label">Order Summary</span>
              </div>
            </div>

            {/* Main Layout */}
            <div className="dp-cart-layout">
              {/* Left Column: Cart Items + Billing Details */}
              <div className="dp-cart-left-column">
                {/* Cart Items Section */}
                <div className="dp-cart-items-section">
                  <div className="dp-cart-select-header">
                    <label className="dp-select-all">
                      <input
                        type="checkbox"
                        checked={isAllSelected}
                        onChange={(e) => handleSelectAll(e.target.checked)}
                      />
                      Select All ({itemCount})
                    </label>
                    <span className="dp-remove-selected" onClick={clearCart}>
                      <i className="far fa-trash-alt"></i>
                      Remove Selected
                    </span>
                  </div>

                  {cartItems.map((item) => (
                    <div key={item?.id} className="dp-cart-item">
                      <input
                        type="checkbox"
                        className="dp-cart-item-checkbox"
                        checked={selectedItems.includes(item?.id)}
                        onChange={(e) => handleSelectItem(item?.id, e.target.checked)}
                      />

                      {item?.product?.image && (
                        <img
                          src={item?.product?.image}
                          alt={item?.product?.name}
                          className="dp-cart-item-image"
                        />
                      )}

                      <div className="dp-cart-item-info">
                        <h4 className="dp-cart-item-name">{item?.product?.name}</h4>
                        <p className="dp-cart-item-desc">{item?.product?.description}</p>
                        <span className="dp-cart-item-stock">
                          <i className="fas fa-check-circle"></i>
                          In Stock
                        </span>
                      </div>

                      <div className="dp-cart-item-price">
                        <span className="dp-price-current">Rs.{item?.product?.discount_price}</span>
                        {item?.product?.base_price > item?.product?.discount_price && (
                          <>
                            <span className="dp-price-original">Rs.{item?.product?.base_price}</span>
                            <span className="dp-price-discount">
                              {Math.round(((item?.product?.base_price - item?.product?.discount_price) / item?.product?.base_price) * 100)}% OFF
                            </span>
                          </>
                        )}
                      </div>

                      <div className="dp-quantity-controls">
                        <button
                          className="dp-qty-btn"
                          onClick={() =>
                            updateQty(
                              item?.product.id,
                              Number(item?.qty) - 1,
                              item?.qty,
                              item?.product?.stock
                            )
                          }
                        >
                          -
                        </button>
                        <span className="dp-qty-value">{item?.qty}</span>
                        <button
                          className="dp-qty-btn"
                          onClick={() =>
                            updateQty(
                              item?.product.id,
                              Number(item?.qty) + 1,
                              item?.qty,
                              item?.product?.stock
                            )
                          }
                        >
                          +
                        </button>
                      </div>

                      <button
                        className="dp-cart-item-delete"
                        onClick={() =>
                          updateQty(
                            item?.product.id,
                            0,
                            item?.qty,
                            item?.product?.stock
                          )
                        }
                      >
                        <i className="far fa-trash-alt"></i>
                      </button>
                    </div>
                  ))}

                  <div className="dp-cart-footer">
                    <Link to="/games" className="dp-continue-shopping">
                      <i className="far fa-arrow-left"></i>
                      Continue Shopping
                    </Link>
                    <span className="dp-clear-cart" onClick={clearCart}>
                      <i className="far fa-trash"></i>
                      Clear Cart
                    </span>
                  </div>
                </div>

                {/* Billing Details Section */}
                <div className="dp-checkout-form">
                  <div className="dp-checkout-form-header">
                    <h3>
                      <i className="far fa-map-marker-alt"></i>
                      Billing Details
                    </h3>
                    {userData?.id && (
                      <span className="dp-user-id-badge">
                        ID: {userData?.id}
                      </span>
                    )}
                  </div>
                  <div className="dp-checkout-form-body">
                    <div className="dp-form-grid">
                      <div className="dp-form-group">
                        <label className="dp-form-label">Full Name <span>*</span></label>
                        <input
                          type="text"
                          className="dp-form-input"
                          placeholder="Enter your full name"
                          value={billingDetails.fullName}
                          onChange={(e) => handleBillingChange('fullName', e.target.value)}
                        />
                      </div>
                      <div className="dp-form-group">
                        <label className="dp-form-label">Phone <span>*</span></label>
                        <input
                          type="tel"
                          className="dp-form-input"
                          placeholder="Enter phone number"
                          value={billingDetails.phone}
                          onChange={(e) => handleBillingChange('phone', e.target.value)}
                        />
                      </div>
                      <div className="dp-form-group">
                        <label className="dp-form-label">Email Address</label>
                        <input
                          type="email"
                          className="dp-form-input"
                          placeholder="Enter email address"
                          value={billingDetails.email}
                          onChange={(e) => handleBillingChange('email', e.target.value)}
                        />
                      </div>
                      <div className="dp-form-group">
                        <label className="dp-form-label">Mobile Number</label>
                        <input
                          type="tel"
                          className="dp-form-input"
                          placeholder="Enter mobile number"
                          value={billingDetails.mobile}
                          onChange={(e) => handleBillingChange('mobile', e.target.value)}
                        />
                      </div>
                      <div className="dp-form-group full-width">
                        <label className="dp-form-label">Address <span>*</span></label>
                        <textarea
                          className="dp-form-input"
                          placeholder="Enter your complete delivery address"
                          value={billingDetails.addressLine}
                          onChange={(e) => handleBillingChange('addressLine', e.target.value)}
                          rows={3}
                          style={{ resize: 'none' }}
                        />
                      </div>
                      <div className="dp-form-group">
                        <label className="dp-form-label">City <span>*</span></label>
                        <input
                          type="text"
                          className="dp-form-input"
                          placeholder="Enter city"
                          value={billingDetails.city}
                          onChange={(e) => handleBillingChange('city', e.target.value)}
                        />
                      </div>
                      <div className="dp-form-group">
                        <label className="dp-form-label">State / Province <span>*</span></label>
                        <input
                          type="text"
                          className="dp-form-input"
                          placeholder="Enter state"
                          value={billingDetails.state}
                          onChange={(e) => handleBillingChange('state', e.target.value)}
                        />
                      </div>
                      <div className="dp-form-group">
                        <label className="dp-form-label">Pincode <span>*</span></label>
                        <input
                          type="text"
                          className="dp-form-input"
                          placeholder="Enter pincode"
                          value={billingDetails.pincode}
                          onChange={(e) => handleBillingChange('pincode', e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="dp-save-address">
                      <input
                        type="checkbox"
                        id="saveAddress"
                        checked={saveAddress}
                        onChange={(e) => setSaveAddress(e.target.checked)}
                      />
                      <label htmlFor="saveAddress">Save address for future orders</label>
                    </div>
                  </div>
                </div>
              </div>

              {/* Order Summary Sidebar */}
              <div className="dp-order-summary">
                <div className="dp-order-summary-header">
                  <h3>
                    <i className="far fa-receipt"></i>
                    Order Summary
                  </h3>
                </div>
                <div className="dp-order-summary-body">
                  {/* Order Items Preview */}
                  <div className="dp-order-items-preview">
                    {cartItems.map((item) => (
                      <div key={item?.id} className="dp-order-item-row">
                        <div className="dp-order-item-thumb">
                          {item?.product?.image && (
                            <img src={item?.product?.image} alt={item?.product?.name} />
                          )}
                          <span className="dp-order-item-qty">{item?.qty}</span>
                        </div>
                        <div className="dp-order-item-detail">
                          <span className="dp-order-item-name">{item?.product?.name}</span>
                        </div>
                        <span className="dp-order-item-price">Rs.{item?.product?.discount_price}</span>
                      </div>
                    ))}
                  </div>

                  <div className="dp-price-divider"></div>

                  <div className="dp-price-details">
                    <h4>Price Details</h4>
                    <div className="dp-price-row">
                      <span className="label">Subtotal ({itemCount} items)</span>
                      <span className="value">Rs.{cart?.sub_total || 0}</span>
                    </div>
                    {savings > 0 && (
                      <div className="dp-price-row discount">
                        <span className="label">Discount</span>
                        <span className="value">-Rs.{savings}</span>
                      </div>
                    )}
                    <div className="dp-price-row">
                      <span className="label">Tax</span>
                      <span className="value">Rs.{cart?.tax_amount || 0}</span>
                    </div>
                    <div className="dp-price-row shipping">
                      <span className="label">Shipping</span>
                      <span className="value">FREE</span>
                    </div>
                  </div>

                  <div className="dp-price-divider"></div>

                  <div className="dp-price-total">
                    <span className="label">Total Amount</span>
                    <span className="value">Rs.{cart?.total_amount || 0}</span>
                  </div>

                  {savings > 0 && (
                    <div className="dp-savings-badge">
                      <i className="far fa-badge-check"></i>
                      <span>You are saving Rs.{savings} on this order!</span>
                    </div>
                  )}

                  <button
                    className="dp-checkout-btn"
                    disabled={!itemCount || checkoutLoading}
                    onClick={(e) => {
                      e.preventDefault();
                      checkoutClicked();
                    }}
                  >
                    {checkoutLoading ? (
                      <>
                        <i className="fas fa-spinner fa-spin"></i>
                        Processing...
                      </>
                    ) : (
                      <>
                        <i className="far fa-lock"></i>
                        Continue to Payment
                      </>
                    )}
                  </button>

                  {/* Promo Code */}
                  <div className="dp-promo-section">
                    <div className="dp-promo-input-group">
                      <input
                        type="text"
                        className="dp-promo-input"
                        placeholder="Apply coupon code"
                      />
                      <button className="dp-promo-btn">Apply</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Trust Badges */}
            <div className="dp-trust-badges">
              <div className="dp-trust-badge">
                <div className="dp-trust-badge-icon">
                  <i className="far fa-shield-check"></i>
                </div>
                <div className="dp-trust-badge-text">
                  <h4>100% Secure Payment</h4>
                  <p>Your transactions are encrypted</p>
                </div>
              </div>
              <div className="dp-trust-badge">
                <div className="dp-trust-badge-icon">
                  <i className="far fa-truck"></i>
                </div>
                <div className="dp-trust-badge-text">
                  <h4>Fast & Free Delivery</h4>
                  <p>On orders above Rs.500</p>
                </div>
              </div>
              <div className="dp-trust-badge">
                <div className="dp-trust-badge-icon">
                  <i className="far fa-undo"></i>
                </div>
                <div className="dp-trust-badge-text">
                  <h4>Easy Returns</h4>
                  <p>7 days return policy</p>
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      {showPaymentModal && (
        <CartPaymentPopup
          setShowModal={setShowPaymentModal}
          showModal={showPaymentModal}
          transactionInProgress={transactionInProgress}
        />
      )}

      <PaymentMethodPopup
        isOpen={showPaymentMethodModal}
        onClose={() => setShowPaymentMethodModal(false)}
        onSelectWallet={handleWalletPayment}
        onSelectDirect={handleDirectPayment}
        walletBalance={walletBalance}
      />
    </div>
  );
};

export default MainSection;
